var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo } from "react";
import { fixedForwardRef } from "../../../common/LibComponentProps";
import { addIconSVG } from "../../technical-fundamental/Icon/Icon/Icon.utils";
var UnwrappedLink = function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var _a = props.as, Component = _a === void 0 ? "a" : _a, isSimple = props.isSimple, issimple = props.issimple, children = props.children, external = props.external, title = props.title, icon = props.icon, iconSvg = props.iconSvg, _b = props.iconPosition, iconPosition = _b === void 0 ? "right" : _b, download = props.download, detail = props.detail, size = props.size, className = props.className, style = props.style, otherProps = __rest(props, ["as", "isSimple", "issimple", "children", "external", "title", "icon", "iconSvg", "iconPosition", "download", "detail", "size", "className", "style"]);
    var isSimpleLink = useMemo(function () {
        if (isSimple === undefined && issimple) {
            return !!issimple;
        }
        return isSimple;
    }, [issimple, isSimple]);
    var combinedClassName = useMemo(function () {
        var classNameArray = [];
        if (className) {
            classNameArray.push(className);
        }
        if (isSimpleLink) {
            classNameArray.push("fr-link");
        }
        if (size && size !== "md") {
            classNameArray.push("fr-link--".concat(size));
        }
        if (icon) {
            classNameArray.push("".concat(icon, " fr-link--icon-").concat(iconPosition));
        }
        if (iconSvg) {
            classNameArray.push("fr-link--icon-".concat(iconPosition));
        }
        if (download) {
            classNameArray.push("fr-link--download");
        }
        return classNameArray.length > 0 ? classNameArray.join(" ") : undefined;
    }, [external, icon, download, size, className, isSimpleLink]);
    var _c = addIconSVG(iconSvg, combinedClassName, style), linkClassName = _c.className, linkStyle = _c.style;
    useEffect(function verifyIfTitleIsRequired() {
        if (external && !title) {
            console.warn("Title is required for external links.");
        }
    }, [external, title]);
    useEffect(function verifyIfDetailIsRequired() {
        if (download && !detail) {
            console.warn("Detail is required for download links.");
        }
    }, [download, detail]);
    var _d = useMemo(function () {
        var target = undefined;
        var rel = undefined;
        if (external) {
            target = "_blank";
            rel = "noopener noreferrer external";
        }
        else if ((iconPosition === "left" || iconPosition === "right") && !download && !title && !size) {
            target = "_self";
        }
        var suffixTitle = external ? "".concat(title, " - ouvre une nouvelle fen\u00EAtre") : title;
        var shouldDownload = download && detail;
        return [target, rel, suffixTitle, shouldDownload];
    }, [external, iconPosition, download, title, size, detail]), target = _d[0], rel = _d[1], suffixTitle = _d[2], shouldDownload = _d[3];
    var allProps = __assign({ download: shouldDownload ? download : undefined, ref: ref }, otherProps);
    return (React.createElement(Component, __assign({ className: linkClassName, target: target, rel: rel, title: suffixTitle, style: linkStyle }, allProps),
        children,
        shouldDownload && React.createElement("span", { className: "fr-link__detail" }, detail)));
};
var Link = fixedForwardRef(UnwrappedLink);
export default Link;
